import React, { useState } from "react";
import SEO from "./SEO";
import { submitToWeb3Forms } from "../utils/web3forms";

const Contact: React.FC = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    phoneNumber: "",
    email: "",
    message: "",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const [status, setStatus] = useState<
    "idle" | "sending" | "success" | "error"
  >("idle");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus("sending");
    const ok = await submitToWeb3Forms("New Contact Page Enquiry", {
      name: formData.firstName,
      email: formData.email,
      phone: formData.phoneNumber,
      message: formData.message,
    });
    if (ok) {
      setStatus("success");
      setFormData({
        firstName: "",
        phoneNumber: "",
        email: "",
        message: "",
      });
    } else {
      setStatus("error");
    }
  };

  const contactMethods = [
    {
      title: "Phone",
      value: "+27 69 946 4074",
      link: "tel:+27699464074",
      icon: (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
          />
        </svg>
      ),
    },
    {
      title: "Email",
      value: "info@thestableshorserides.co.za",
      link: "mailto:info@thestableshorserides.co.za",
      icon: (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
          />
        </svg>
      ),
    },
    {
      title: "Address",
      value: "The Stables, R964, Pretoria East, Boschkop",
      link: "https://maps.google.com",
      icon: (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </svg>
      ),
    },
  ];

  const socialLinks = [
    {
      name: "Facebook",
      url: "https://www.facebook.com/thestableshorserides",
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
        </svg>
      ),
    },
    {
      name: "Instagram",
      url: "https://www.instagram.com/thestables.horserides/",
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 6.62 5.367 11.987 11.988 11.987 6.62 0 11.987-5.367 11.987-11.987C24.014 5.367 18.637.001 12.017.001zM8.449 16.988c-1.297 0-2.448-.49-3.323-1.297C4.198 14.895 3.708 13.744 3.708 12.447s.49-2.448 1.297-3.323c.875-.807 2.026-1.297 3.323-1.297s2.448.49 3.323 1.297c.807.875 1.297 2.026 1.297 3.323s-.49 2.448-1.297 3.323c-.875.807-2.026 1.297-3.323 1.297zm7.718-1.297c-.875.807-2.026 1.297-3.323 1.297s-2.448-.49-3.323-1.297c-.807-.875-1.297-2.026-1.297-3.323s.49-2.448 1.297-3.323c.875-.807 2.026-1.297 3.323-1.297s2.448.49 3.323 1.297c.807.875 1.297 2.026 1.297 3.323s-.49 2.448-1.297 3.323z" />
        </svg>
      ),
    },
  ];

  return (
    <div className="min-h-screen">
      <SEO
        title="Contact The Stables | Horse Rides Pretoria East, Boschkop"
        description="Get in touch with The Stables in Pretoria East. Call +27 69 946 4074, email info@thestableshorserides.co.za, or use our contact form to book your horse riding experience."
        path="/contact"
      />
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center bg-gradient-to-br from-cream-50 via-stables-50 to-stables-100">
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: "url(Stables5.jpg)",
          }}
        ></div>
        <div className="absolute inset-0 bg-black bg-opacity-30"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-transparent"></div>
        <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold mb-6">Contact Us</h1>
          <p className="text-xl md:text-2xl mb-8 font-light">
            Get in touch with us to book your horse riding experience or ask any
            questions
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:+27699464074"
              className="bg-stables-600 hover:bg-stables-700 text-white px-6 py-3 rounded-lg text-base font-semibold transition-colors duration-300"
            >
              Call Now
            </a>
            <a
              href="mailto:info@thestableshorserides.co.za"
              className="bg-white text-stables-800 hover:bg-stables-100 px-6 py-3 rounded-lg text-base font-semibold transition-colors duration-300"
            >
              Email Us
            </a>
          </div>
        </div>
      </section>

      {/* Contact Information */}
      <section className="py-20 bg-gradient-to-br from-cream-50 to-stables-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-stables-800 mb-4">
              Get In Touch
            </h2>
            <p className="text-xl text-stables-600">
              We'd love to hear from you and help plan your perfect horse riding
              experience
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-16">
            {/* Contact Details */}
            <div className="space-y-8">
              {/* Contact Methods */}
              <div className="space-y-6">
                {contactMethods.map((method, index) => (
                  <div key={index} className="group relative">
                    {/* Card Background */}
                    <div className="absolute inset-0 bg-gradient-to-r from-stables-600 to-stables-700 rounded-3xl sm:rotate-1 sm:group-hover:rotate-2 transition-transform duration-300"></div>

                    {/* Card Content */}
                    <div className="relative bg-white rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 border border-stables-200 p-6">
                      <a
                        href={method.link}
                        className="flex items-center space-x-4 group-hover:scale-105 transition-transform duration-300"
                      >
                        <div className="w-12 h-12 bg-gradient-to-r from-stables-500 to-stables-600 rounded-full flex items-center justify-center text-white">
                          {method.icon}
                        </div>
                        <div className="flex-1">
                          <h3 className="text-lg font-semibold text-stables-800">
                            {method.title}
                          </h3>
                          <p className="text-stables-600">{method.value}</p>
                        </div>
                        <div className="text-stables-400 group-hover:text-stables-600 transition-colors">
                          <svg
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M9 5l7 7-7 7"
                            />
                          </svg>
                        </div>
                      </a>
                    </div>
                  </div>
                ))}
              </div>

              {/* Social Media */}
              <div className="group relative">
                <div className="absolute inset-0 bg-gradient-to-r from-stables-600 to-stables-700 rounded-3xl sm:rotate-1 sm:group-hover:rotate-2 transition-transform duration-300"></div>
                <div className="relative bg-white rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 border border-stables-200 p-6">
                  <h3 className="text-xl font-semibold text-stables-800 mb-4">
                    Follow Us
                  </h3>
                  <div className="flex space-x-4">
                    {socialLinks.map((social, index) => (
                      <a
                        key={index}
                        href={social.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-12 h-12 bg-gradient-to-r from-stables-500 to-stables-600 rounded-full flex items-center justify-center text-white hover:scale-110 transition-transform duration-300"
                      >
                        {social.icon}
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="group relative">
              <div className="absolute inset-0 bg-gradient-to-r from-stables-600 to-stables-700 rounded-3xl sm:rotate-1 sm:group-hover:rotate-2 transition-transform duration-300"></div>
              <div className="relative bg-white rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 border border-stables-200 p-8">
                <h2 className="text-3xl font-bold text-stables-800 mb-8">
                  Send Us a Message
                </h2>
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div>
                    <label
                      htmlFor="firstName"
                      className="block text-sm font-semibold text-stables-700 mb-2"
                    >
                      First Name
                    </label>
                    <input
                      type="text"
                      id="firstName"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-stables-300 rounded-lg focus:ring-2 focus:ring-stables-500 focus:border-transparent transition-colors duration-200 bg-white"
                      placeholder="Your first name"
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="phoneNumber"
                      className="block text-sm font-semibold text-stables-700 mb-2"
                    >
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      id="phoneNumber"
                      name="phoneNumber"
                      value={formData.phoneNumber}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-stables-300 rounded-lg focus:ring-2 focus:ring-stables-500 focus:border-transparent transition-colors duration-200 bg-white"
                      placeholder="Your phone number"
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="email"
                      className="block text-sm font-semibold text-stables-700 mb-2"
                    >
                      Email
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-stables-300 rounded-lg focus:ring-2 focus:ring-stables-500 focus:border-transparent transition-colors duration-200 bg-white"
                      placeholder="Your email address"
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="message"
                      className="block text-sm font-semibold text-stables-700 mb-2"
                    >
                      Message
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows={5}
                      className="w-full px-4 py-3 border border-stables-300 rounded-lg focus:ring-2 focus:ring-stables-500 focus:border-transparent transition-colors duration-200 bg-white"
                      placeholder="Tell us about your horse riding needs..."
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    disabled={status === "sending"}
                    className="w-full bg-gradient-to-r from-stables-600 to-stables-700 hover:from-stables-700 hover:to-stables-800 text-white py-3 rounded-lg text-base font-semibold transition-all duration-300 transform hover:scale-105 disabled:opacity-60 disabled:hover:scale-100"
                  >
                    {status === "sending" ? "Sending..." : "Send Message"}
                  </button>
                  {status === "success" && (
                    <p role="status" className="text-green-700 text-sm font-medium">
                      Thank you! Your message has been sent. We'll be in touch soon.
                    </p>
                  )}
                  {status === "error" && (
                    <p role="alert" className="text-red-600 text-sm font-medium">
                      Something went wrong. Please try again or WhatsApp us on +27 69 946 4074.
                    </p>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-stables-800 mb-6">
              Find Us
            </h2>
            <p className="text-xl text-stables-700">
              Located in the beautiful countryside of Pretoria East, Boschkop
            </p>
          </div>

          <div className="group relative">
            <div className="absolute inset-0 bg-gradient-to-r from-stables-600 to-stables-700 rounded-3xl sm:rotate-1 sm:group-hover:rotate-2 transition-transform duration-300"></div>
            <div className="relative bg-white rounded-3xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28739.572603251956!2d28.42557448215069!3d-25.78883724939969!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e955bbdfc0c3077%3A0x26b866ee84a006d8!2sThe%20Stables%20-%20Horse%20Rides!5e0!3m2!1sen!2sza!4v1777998768422!5m2!1sen!2sza"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="The Stables location"
              />
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Link */}
      <section className="py-20 bg-gradient-to-r from-stables-600 to-stables-700 text-white">
        <div className="max-w-4xl mx-auto text-center px-4">
          <div className="relative">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-0 left-0 w-32 h-32 border-2 border-white rounded-full"></div>
              <div className="absolute top-8 right-8 w-16 h-16 border-2 border-white rounded-full"></div>
              <div className="absolute bottom-8 left-8 w-24 h-24 border-2 border-white rounded-full"></div>
            </div>

            <div className="relative z-10">
              <h2 className="text-4xl font-bold mb-6">Have Questions?</h2>
              <p className="text-xl mb-8 text-stables-100">
                Check out our FAQ section for answers to common questions about
                our horse riding experiences.
              </p>
              <a
                href="/faq"
                className="bg-white text-stables-800 hover:bg-cream-50 px-6 py-3 rounded-lg text-base font-semibold transition-colors duration-300 transform hover:scale-105"
              >
                View FAQ
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
